var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('copy-from', {
    attrs: {
      "dataForm": _vm.dataForm,
      "options": _vm.packageList,
      "labelFormatter": function labelFormatter(item) {
        return "[".concat(item.packageCode, "]").concat(item.packageName);
      }
    },
    on: {
      "copyFromTrigger": _vm.copyFromTrigger
    }
  })], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Package Code",
      "prop": "packageCode"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "clearable": "",
      "placeholder": "PKG-001"
    },
    model: {
      value: _vm.dataForm.packageCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "packageCode", $$v);
      },
      expression: "dataForm.packageCode"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Country"
    },
    on: {
      "change": _vm.countryChange
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" Business Type "), _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "content": "Select country first"
    }
  }, [_c('i', {
    staticClass: "el-icon-info",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _c('el-select', {
    staticClass: "fluid-width",
    attrs: {
      "clearable": "",
      "placeholder": "Select Business Type"
    },
    on: {
      "change": _vm.setServiceOptions
    },
    model: {
      value: _vm.dataForm.businessType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "businessType", $$v);
      },
      expression: "dataForm.businessType"
    }
  }, _vm._l(_vm.supportBusinessTypesOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "supplierId"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" Supplier "), _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "content": "Select country first"
    }
  }, [_c('i', {
    staticClass: "el-icon-info",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _c('el-select', {
    staticClass: "fluid-width",
    attrs: {
      "clearable": "",
      "placeholder": "Select Supplier"
    },
    on: {
      "change": _vm.setServiceOptions
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.supplierOptions, function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Package Name (EN)",
      "prop": "packageName"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "clearable": "",
      "placeholder": "Package Name (EN)"
    },
    model: {
      value: _vm.dataForm.packageName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "packageName", $$v);
      },
      expression: "dataForm.packageName"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Package Name (CN)",
      "prop": "packageNameCn"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Package Name (CN)"
    },
    model: {
      value: _vm.dataForm.packageNameCn,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "packageNameCn", $$v);
      },
      expression: "dataForm.packageNameCn"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Package Name (Local)",
      "prop": "packageNameLocal"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Package Name (Local)"
    },
    model: {
      value: _vm.dataForm.packageNameLocal,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "packageNameLocal", $$v);
      },
      expression: "dataForm.packageNameLocal"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Applicable Person (EN)",
      "prop": "applicablePerson"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "type": "textarea",
      "rows": 3,
      "resize": "none",
      "clearable": "",
      "placeholder": "Applicable Person (EN)"
    },
    model: {
      value: _vm.dataForm.applicablePerson,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "applicablePerson", $$v);
      },
      expression: "dataForm.applicablePerson"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Applicable Person (CN)",
      "prop": "applicablePersonCn"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "resize": "none",
      "clearable": "",
      "placeholder": "Applicable Person (CN)"
    },
    model: {
      value: _vm.dataForm.applicablePersonCn,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "applicablePersonCn", $$v);
      },
      expression: "dataForm.applicablePersonCn"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Currency",
      "prop": "currency"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Select Currency"
    },
    on: {
      "change": _vm.setServiceOptions
    },
    model: {
      value: _vm.dataForm.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "currency", $$v);
      },
      expression: "dataForm.currency"
    }
  }, _vm._l(_vm.currencyList, function (item) {
    return _c('el-option', {
      key: item.currency,
      attrs: {
        "label": item.currency,
        "value": item.currency
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input', {
    directives: [{
      name: "positivePoint",
      rawName: "v-positivePoint"
    }],
    attrs: {
      "placeholder": "0.00"
    },
    model: {
      value: _vm.dataForm.price,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "price", $$v);
      },
      expression: "dataForm.price"
    }
  }, [_c('template', {
    slot: "prefix"
  }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.dataForm.currency)))])], 2)], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Services",
      "prop": "serviceIds"
    }
  }, [_c('select-Service', {
    attrs: {
      "businessType": _vm.dataForm.businessType,
      "supplierId": _vm.dataForm.supplierId,
      "currency": _vm.dataForm.currency,
      "checkboxOptionList": _vm.serviceOptions,
      "echoSelectedServiceList": _vm.echoSelectedServiceList
    },
    model: {
      value: _vm.dataForm.serviceIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "serviceIds", $$v);
      },
      expression: "dataForm.serviceIds"
    }
  })], 1)], 1)], 1), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Sort No.",
      "prop": "orderNum"
    }
  }, [_c('el-input', {
    directives: [{
      name: "positiveInteger",
      rawName: "v-positiveInteger"
    }],
    attrs: {
      "clearable": "",
      "placeholder": "Order Number"
    },
    model: {
      value: _vm.dataForm.orderNum,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "orderNum", $$v);
      },
      expression: "dataForm.orderNum"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Status",
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: _vm.dataForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "status", $$v);
      },
      expression: "dataForm.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("Disable")]), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("Enable")])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "pt16"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("Submit")]), _c('el-button', {
    on: {
      "click": function click() {
        return _vm.$router.replace('/sys/pkg/plan');
      }
    }
  }, [_vm._v("Back")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }